import styled from 'styled-components';

import {Message as BaseMessage} from 'src/components';

export const Message = styled(BaseMessage)`
  margin: 0;
  padding: 0;
  box-shadow: none;
`;
